export default "__VITE_ASSET__BjQHEV2A__"